import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { useT } from "@/context/LanguageContext";

export default function Coverage({ contact }) {
  const { t, ui } = useT();
  const area = t(contact?.service_area) || "Maryland & DMV";
  const areas = [
    { code: "MD", label: ui("coverage.md.label"), body: ui("coverage.md.body") },
    { code: "DMV", label: ui("coverage.dmv.label"), body: ui("coverage.dmv.body") },
  ];

  return (
    <section className="relative bg-[color:var(--gcs-ivory-2)] py-24 md:py-32" data-testid="coverage-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <p className="overline text-[color:var(--gcs-gold)] mb-4">{ui("coverage.chapter")}</p>
            <h2 className="font-serif text-4xl md:text-5xl leading-[1.02] tracking-tight text-[color:var(--gcs-emerald)]">
              {ui("coverage.h1_a")}<em className="text-[color:var(--gcs-gold)]">{area}</em>.
            </h2>
            <p className="mt-6 text-[color:var(--gcs-emerald)]/75 max-w-md leading-relaxed">
              {ui("coverage.lead")}
            </p>
          </div>
          <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {areas.map((a, i) => (
              <motion.div
                key={a.code}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="p-8 rounded-sm bg-[color:var(--gcs-ivory)] border border-[color:var(--gcs-line)]"
                data-testid={`coverage-area-${i}`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <MapPin className="w-4 h-4 text-[color:var(--gcs-gold)]" />
                  <span className="overline text-[color:var(--gcs-gold)]">{a.code}</span>
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-[color:var(--gcs-emerald)] mb-3">{a.label}</h3>
                <p className="text-sm text-[color:var(--gcs-emerald)]/75 leading-relaxed">{a.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
